import { EventService } from './../shared/event.service';
import { CartService } from './../cart/cart.service';
import { CourtCase } from './../shared/court-case';
import { Injectable } from '@angular/core';

@Injectable()
export class CaseViewService {

  private selectedCase: CourtCase;

  constructor(private cartService: CartService,
              private eventService: EventService) { }

  getSelectedCase(): CourtCase {
    return this.selectedCase;
  }
  setSelectedCase(selectedCase: CourtCase): void {
    this.selectedCase = selectedCase;
  }

  isCaseInCart(): boolean {
    return this.selectedCase &&
           this.cartService.contains(this.selectedCase.getCaseIdentifier());
  }
  addCaseToCart(): void {
    this.cartService.addCase(this.selectedCase);
  }
  removeCaseFromCart(): void {
    this.cartService.removeCase(this.selectedCase);
  }

  onEmailClicked(): void {
    this.eventService.openEmail([this.selectedCase]);
  }
  onHelpClicked(): void {
    this.eventService.openHelp();
  }
  onPrintClicked(): void {
    this.eventService.openPrint([this.selectedCase]);
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/case-view.service.ts